import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase/client';

export interface ProductPerformanceData {
    product_name: string;
    call_count: number;
    resolution_rate: number;
    satisfaction_rate: number;
    pain_points_rate: number;
    avg_duration: number;
    performance_rate: number;
    reiteration_rate: number;
}

interface UseProductPerformanceParams {
    projectId: number | null;
    startDate?: Date | null;
    endDate?: Date | null;
    enabled?: boolean;
}

export const useProductPerformance = ({
    projectId,
    startDate,
    endDate,
    enabled = true,
}: UseProductPerformanceParams) => {
    return useQuery({
        queryKey: ['product-performance', projectId, startDate, endDate],
        queryFn: async () => {
            if (!projectId) {
                throw new Error('Project ID is required');
            }

            const { data, error } = await supabase.rpc('get_product_performance', {
                p_project_id: projectId,
                p_start_date: startDate?.toISOString() || null,
                p_end_date: endDate?.toISOString() || null,
            });

            if (error) {
                console.error('Error fetching product performance:', error);
                throw error;
            }

            return (data || []) as ProductPerformanceData[];
        },
        enabled: !!projectId && enabled,
        staleTime: 5 * 60 * 1000,
        gcTime: 30 * 60 * 1000,
        refetchOnWindowFocus: false,
    });
};
